import React from 'react'
import styled from 'styled-components'
import BodyText from 'LuxKit/Typography/BodyText'
import { MERCHANDISE_MAX_QUANTITY_MESSAGE } from './merchandiseUtils'

const StyledMessage = styled(BodyText)`
  white-space: nowrap;
`

interface Props {
  align?: 'start' | 'center' | 'end'
}

function MerchandiseMaxQuantityMessage({ align = 'end' }: Props) {
  return (
    <StyledMessage variant="small" colour="neutral-three" align={align}>
      {MERCHANDISE_MAX_QUANTITY_MESSAGE}
    </StyledMessage>
  )
}

export default MerchandiseMaxQuantityMessage
